import React from 'react';
import PropTypes from 'prop-types';
import { Container, Line, Title } from './styles';
import FeatureFlagLine from './feature-flag-line';

const FeatureFlags = ({ onChangeFeatureFlags, featureFlags, featureFlagsErrors }) => {
  const onToggleFeatureFlag = ((featureFlagName) => {
    onChangeFeatureFlags(featureFlagName);
  });
  return (
    <Container>
      <Line>
        <Title>
          Feature Flags
        </Title>
      </Line>
      {
        Object.entries(featureFlags).map(([featureFlagName, { enabled }]) => (
          <FeatureFlagLine
            key={featureFlagName}
            featureFlagName={featureFlagName}
            enabled={!!enabled}
            onToggleFeatureFlag={(newValue) => onToggleFeatureFlag(featureFlagName, newValue)}
            featureFlagError={featureFlagsErrors[featureFlagName]}
          />
        ))
      }
    </Container>
  );
};

FeatureFlags.defaultProps = {
  featureFlagsErrors: [],
};

FeatureFlags.propTypes = {
  onChangeFeatureFlags: PropTypes.func.isRequired,
  featureFlags: PropTypes.objectOf(PropTypes.shape({
    enabled: PropTypes.bool,
  })).isRequired,
  featureFlagsErrors: PropTypes.arrayOf(PropTypes.shape({
    [PropTypes.string]: PropTypes.string,
  })),
};

export default FeatureFlags;
